
import React, { PropsWithChildren, useCallback, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './AdobeModeTrigger.css';
import { CompareApi } from '../../utils/compare-api/CompareApi';
import SessionStorage from '../../utils/SessionStorage';
import { Button } from '../../importCL';

interface IAdobeModeTriggerProps extends MappedComponentProperties {
  title?: string;
  successURL?: string;
  corporate?: boolean;
}

export const AdobeModeTriggerEditConfig = {
    emptyLabel: 'Adobe Mode Trigger',
    isEmpty: (props: PropsWithChildren<IAdobeModeTriggerProps>) => {
        return !props || !props.title;
    },
};

const AdobeModeTrigger = (props: PropsWithChildren<IAdobeModeTriggerProps>): JSX.Element => {
    const [usePhoneApi, setUsePhoneApi] = useState(false);
    const handleAdobeModeOnClick = useCallback(() => {
        const initAdobe =  props.corporate ? CompareApi.initializeCorporateAdobeModeApi : CompareApi.initializeAcquisitionsAdobeModeApi;
        initAdobe().then(() => {
            window.location.assign(props.successURL as string);
        });
    }, []);

    const initPhoneApi = useCallback(() => (SessionStorage.set('usePhoneApi', 'True'), setUsePhoneApi(true)), []);

    return (
        <div id='adobe-mode-trigger' style={{ height: window.innerHeight }} className='AdobeModeTrigger'>
            <h1 className='AdobeModeTrigger__title'>
                {props.title}
            </h1>
            <label>
                <button onClick={initPhoneApi}>Use Phone Validation Api</button>
                {usePhoneApi && '✅'}
            </label>
            <Button onClick={handleAdobeModeOnClick}>Start Adobe Mode</Button>
        </div>
    );
};

export default AdobeModeTrigger;
